module.exports = __webpack_public_path__ + "static/media/light3.adce7809.png";